export const doubleIdRegExp = /^\d+\|\d+$/;
